import 'moment/locale/th';
import React, { useState, useEffect } from 'react';
import { formatComma, tableWidth, getTheme } from 'helpers/helpers';
import callApi from 'helpers/callapi';
import moment from 'moment';
import _, { get, find, orderBy, uniqBy, filter } from 'lodash';
import { Link } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import PROVINCES from 'constants/all-provinces.json';

// Components
import CONSTANTS from 'constants/constants';
import { Button, Table, Pagination, Modal, Row, Col, Select, message, Input, Upload, Switch, Spin, Tooltip, Tabs } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';


import cn from 'classnames';
import { filterLabelAndValue } from 'helpers/helpers';

// constants
import ROUNDS from 'constants/rounds';
import TCAS_STATUSES from 'constants/tcas_statuses';
import DownloadModal from './DownloadModal';
import { HISTORY_YEAR, buildHistoryDayBySchool, DiffValue } from 'helpers/site-history';

// import AdminDetailModal from './AdminModal';

const ORDER_STATUS = CONSTANTS.orderStatus;
const ORDER_LABEL = CONSTANTS.orderLabels;
const BANK = CONSTANTS.banks;
const BKK_METRO_PROVINCES = ['กรุงเทพมหานคร', 'นนทบุรี', 'ปทุมธานี', 'สมุทรปราการ', 'สมุทรสาคร', 'นครปฐม'];
const BKK_METRO_LABEL = 'กรุงเทพและปริมณฑล';

const Option = Select.Option;

const DAYS = [4, 5, 6]
const DEFAULT_KEY = '3'

const num = (value) => (value ? formatComma(value) : '-');

// ที่นั่งของวันนั้น รวมทุกประเภท (ปกติ + พิเศษ + CBT) ให้นิยามตรงกับยอดปี 69 ที่รวม CBT มาแล้ว
const currentDaySeats = (site, day) => {
  const data = get(site, `info_by_days.day${day}`);
  return (get(data, 'seats') || 0) + (get(data, 'special_seats') || 0) + (get(data, 'cbt_seats') || 0);
};

// รวมที่นั่งรายวันของปีนี้ ตามคีย์ที่ให้ (province | center_code) → { [key]: { 4: seats, 5: ..., 6: ... } }
const currentSeatsBy = (sites, keyField) => {
  const result = {};
  (sites || []).forEach((site) => {
    const key = site[keyField];
    if (!key) return;
    if (!result[key]) result[key] = {};
    DAYS.forEach((day) => {
      result[key][day] = (result[key][day] || 0) + currentDaySeats(site, day);
    });
  });
  return result;
};

// รวมที่นั่งรายวันของปี 69 จาก snapshot — รวมสนาม PBT+CBT ของโรงเรียนเดียวกันเหมือนหน้าศูนย์สอบ
const historySeatsBy = (historySites, keyField) => {
  const result = {};
  DAYS.forEach((day) => {
    _.forEach(buildHistoryDayBySchool(historySites, day), (entry) => {
      const key = get(entry, `site.${keyField}`);
      if (!key) return;
      if (!result[key]) result[key] = {};
      result[key][day] = (result[key][day] || 0) + entry.seats;
    });
  });
  return result;
};

// กรุงเทพและปริมณฑลเป็นกลุ่มรวม ไม่ใช่ชื่อจังหวัดจริง ต้องบวกจังหวัดสมาชิกเอง
const seatsOfProvince = (seatsByProvince, province, day) =>
  province === BKK_METRO_LABEL
    ? BKK_METRO_PROVINCES.reduce((sum, name) => sum + get(seatsByProvince, [name, day], 0), 0)
    : get(seatsByProvince, [province, day], 0);

// แถวตารางเทียบ 1 แถว = 1 จังหวัด/ศูนย์สอบ พร้อมยอดรายวันของทั้งสองปี
const buildCompareRow = (key, label, readSeats) => {
  const days = {};
  DAYS.forEach((day) => {
    const previous = readSeats('previous', day);
    const current = readSeats('current', day);
    days[day] = { previous, current, diff: current - previous };
  });
  return { key, label, days, hasData: DAYS.some((day) => days[day].previous || days[day].current) };
};

const sumCompareRows = (rows) => {
  const days = {};
  DAYS.forEach((day) => {
    const previous = _.sumBy(rows, (row) => row.days[day].previous);
    const current = _.sumBy(rows, (row) => row.days[day].current);
    days[day] = { previous, current, diff: current - previous };
  });
  return { days };
};

moment.locale('th');
const emptyDay = {
  seats: 0,
  special_seats: 0,
  cbt_seats: 0
}

const emptyProvince = {
  province: '',
  day1: { ...emptyDay },
  day2: { ...emptyDay },
  day3: { ...emptyDay },
  day4: { ...emptyDay },
  day5: { ...emptyDay },
  day6: { ...emptyDay },
  sites: [],
}

export default () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const me = useSelector((state) => state.user);

  const [loading, setLoading] = useState(false);
  const adminConfig = useSelector((state) => state.configs || {});

  const [sites, setSites] = useState([]);
  const [groupedByProvince, setGroupedByProvince] = useState([]);
  const [groupedByCenter, setGroupedByCenter] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [showOnlyEmpty, setShowOnlyEmpty] = useState(false);
  const [lastyearProvinceData, setLastYearProvinceData] = useState({});
  const [showHeatmap, setShowHeatmap] = useState(false);
  const [showOnlyNegative, setShowOnlyNegative] = useState(false);
  const [historySites, setHistorySites] = useState([]);
  const [compareOnlyNegative, setCompareOnlyNegative] = useState(false);

  const getSumSeats = (info) => {

  }
  const calculateDayStats = (sites, day) => {
    return sites.reduce((results, site) => ({
      seats: results.seats + get(site, `info_by_days.${day}.seats`, 0),
      special_seats: results.special_seats + get(site, `info_by_days.${day}.special_seats`, 0),
      cbt_seats: results.cbt_seats + get(site, `info_by_days.${day}.cbt_seats`, 0),
    }), { seats: 0, cbt_seats: 0, special_seats: 0 });
  };

  const getSchools = async () => {
    const _sites = await callApi({ url: `/exam-centers/dashboard?year=${HISTORY_YEAR}` });
    setSites(_sites.sites);
    setHistorySites(_sites.history_sites || []);

    // Group data by province using lodash
    let provinceGroups = _.groupBy(_sites.sites, 'province');

    provinceGroups = _.map(provinceGroups, (sites, province) => {
      return {
        province: province,
        day1: calculateDayStats(sites, 'day1'),
        day2: calculateDayStats(sites, 'day2'),
        day3: calculateDayStats(sites, 'day3'),
        day4: calculateDayStats(sites, 'day4'),
        day5: calculateDayStats(sites, 'day5'),
        day6: calculateDayStats(sites, 'day6'),
        sites: sites,
      };
    });

    // Create กรุงเทพและปริมณฑล group



    provinceGroups = PROVINCES.map(province => {
      const foundProvince = _.find(provinceGroups, { province });
      if (foundProvince) return foundProvince;
      else return { ...emptyProvince, province: province };
    })
    const bkkMetroSites = _sites.sites.filter(site => BKK_METRO_PROVINCES.includes(site.province));
    const bkkMetroGroup = {
      province: BKK_METRO_LABEL,
      day1: calculateDayStats(bkkMetroSites, 'day1'),
      day2: calculateDayStats(bkkMetroSites, 'day2'),
      day3: calculateDayStats(bkkMetroSites, 'day3'),
      day4: calculateDayStats(bkkMetroSites, 'day4'),
      day5: calculateDayStats(bkkMetroSites, 'day5'),
      day6: calculateDayStats(bkkMetroSites, 'day6'),
      sites: bkkMetroSites,
    };
    provinceGroups.unshift(bkkMetroGroup);


    setGroupedByProvince(provinceGroups);


    // Group data by center_code using lodash
    let centerGroups = _.groupBy(_sites.sites, 'center_code');
    const allCenters = _sites.center_codes;
    centerGroups = _.map(allCenters, (centerCode) => {
      const centerSites = centerGroups[centerCode] || [];
      return {
        center_code: centerCode,
        sites: centerSites,
        day1: calculateDayStats(centerSites, 'day1'),
        day2: calculateDayStats(centerSites, 'day2'),
        day3: calculateDayStats(centerSites, 'day3'),
        day4: calculateDayStats(centerSites, 'day4'),
        day5: calculateDayStats(centerSites, 'day5'),
        day6: calculateDayStats(centerSites, 'day6'),
      };
    });


    setGroupedByCenter(centerGroups);
  };

  const getLastYearSchoolData = async () => {
    try {
      const data = await callApi({
        fullURL: 'https://my-tcas.s3.ap-southeast-1.amazonaws.com/stats/69/province-stat.json',
        method: 'GET'
      });
      // Add กรุงเทพและปริมณฑล by combining BKK metro provinces
      const bkkMetroData = data.filter(item => BKK_METRO_PROVINCES.includes(item.province));
      const bkkMetroCombined = {
        province: BKK_METRO_LABEL,
        // Combine stats from all BKK metro provinces
        ...bkkMetroData.reduce((acc, item) => {
          // Sum up numeric fields
          Object.keys(item).forEach(key => {
            if (key !== 'province' && typeof item[key] === 'number') {
              acc[key] = (acc[key] || 0) + item[key];
            }
          });
          return acc;
        }, {})
      };

      const provinceDict = _.keyBy([...data, bkkMetroCombined], 'province');
      setLastYearProvinceData(provinceDict);
    } catch (error) {
      console.error('Error fetching last year province data:', error);
    }

  };

  useEffect(() => {
    getSchools();
    getLastYearSchoolData();
  }, []);


  const renderSiteTable = (siteList) => (
    <table className="t-table t-table-striped">
      <thead className="th-orange">
        <tr>
          <th>ลำดับ</th>
          <th>ชื่อสนามสอบ</th>
          <th>จังหวัด</th>
          <th>อำเภอ</th>
          {DAYS.map(day => (
            <th key={day} className="text-center" colSpan="3">
              วันที่ {day}
            </th>
          ))}
        </tr>
        <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          {DAYS.map(day => (
            <>
              <th key={`${day}-paper`} className="text-center">
                <Tooltip title="ห้องสอบปกติ กระดาษ">
                  <i className="i-paper"></i>
                </Tooltip>
              </th>
              <th key={`${day}-disabled`} className="text-center">
                <Tooltip title="ห้องสอบสำหรับผู้ต้องการความช่วยเหลือพิเศษ กระดาษ">
                  <i className="i-disabled"></i>
                </Tooltip>
              </th>
              <th key={`${day}-computer`} className="text-center">
                <Tooltip title="ห้องสอบปกติ คอมพิวเตอร์">
                  <i className="i-computer"></i>
                </Tooltip>
              </th>
            </>
          ))
          }

        </tr>
      </thead>
      <tbody>
        {siteList.map((site, index) => {
          const stat = get(site, `stats`);

          return (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{site.school_name}</td>
              <td>{site.province}</td>
              <td>{site.amphur}</td>

              {DAYS.map(day => {
                const data = get(site, `info_by_days.day${day}`);
                return (
                  <>
                    <td key={`${day}-seats`} className="_nowrap text-right">
                      {(_.get(data, 'seats') || 0).toLocaleString()}
                    </td>
                    <td key={`${day}-special`} className="_nowrap text-right">
                      {(_.get(data, 'special_seats') || 0).toLocaleString()}

                    </td>
                    <td key={`${day}-cbt`} className="_nowrap text-right">
                      {(_.get(data, 'cbt_seats') || 0).toLocaleString()}

                    </td>
                  </>
                )
              })}
            </tr>
          );
        })}
        <tr key="total">
          <td colSpan="4" className="_nowrap text-right font-weight-bold"><b>รวม</b></td>

          {DAYS.map(day => {
            const totalSeats = siteList.reduce((sum, site) => {
              const data = get(site, `info_by_days.day${day}`);
              return sum + (_.get(data, 'seats') || 0);
            }, 0);
            const totalSpecialSeats = siteList.reduce((sum, site) => {
              const data = get(site, `info_by_days.day${day}`);
              return sum + (_.get(data, 'special_seats') || 0);
            }, 0);
            const totalCbtSeats = siteList.reduce((sum, site) => {
              const data = get(site, `info_by_days.day${day}`);
              return sum + (_.get(data, 'cbt_seats') || 0);
            }, 0);
            return (
              <>

                <td key={`${day}-total-seats`} className="_nowrap text-right font-weight-bold">
                  {totalSeats.toLocaleString()}
                </td>
                <td key={`${day}-total-special`} className="_nowrap text-right font-weight-bold">
                  {totalSpecialSeats.toLocaleString()}
                </td>
                <td key={`${day}-total-cbt`} className="_nowrap text-right font-weight-bold">
                  {totalCbtSeats.toLocaleString()}
                </td>
              </>
            )
          })}
        </tr>
      </tbody>
    </table>
  );

  const renderProvinceTable = (provinces) => (
    <table className="t-table t-table-striped">
      <thead className="th-orange">
        <tr>
          <th>ลำดับที่</th>
          <th>จังหวัด</th>
          {DAYS.map(day => (
            <th key={`day${day}-header`} className="text-center" colSpan={showHeatmap ? "1" : "3"}>
              วันที่ {day}
            </th>
          ))}

        </tr>
        <tr>
          <th></th>
          <th></th>
          {DAYS.map(day => (
            <>
              <th key={`${day}-paper`} className="text-center">
                <Tooltip title="ห้องสอบปกติ กระดาษ">
                  <i className="i-paper"></i>
                </Tooltip>
              </th>
              {!showHeatmap && (
                <>
                  <th key={`${day}-disabled`} className="text-center">
                    <Tooltip title="ห้องสอบสำหรับผู้ต้องการความช่วยเหลือพิเศษ กระดาษ">
                      <i className="i-disabled"></i>
                    </Tooltip>
                  </th>
                  <th key={`${day}-computer`} className="text-center">
                    <Tooltip title="ห้องสอบปกติ คอมพิวเตอร์">
                      <i className="i-computer"></i>
                    </Tooltip>
                  </th>
                </>
              )}
            </>
          ))
          }

        </tr>


      </thead>
      <tbody>

        {provinces.map((province, i) => {
          const lyProvinceData = lastyearProvinceData[province.province] ? lastyearProvinceData[province.province] : {};
          return <tr key={province.province}>
            <td>{i + 1}</td>
            <td>{province.province}</td>
            {DAYS.map(day => {
              let diff = 0;
              let diffClass = 'bg-white';
              if (showHeatmap && lyProvinceData[`day${day}`]) {
                diff = province[`day${day}`].seats - lyProvinceData[`day${day}`];
                diffClass = diff < -100 ? 'bg-red' : diff < 0 ? 'bg-yellow' : diff > 0 ? 'bg-green' : 'bg-white';

              }

              return (
                <>
                  <td key={`${day}-seats`} className={cn("_nowrap text-center", diffClass)}>
                    {province[`day${day}`].seats.toLocaleString()}
                    {showHeatmap && (
                      <>
                        <span> / {lyProvinceData[`day${day}`] ? lyProvinceData[`day${day}`].toLocaleString() : 0}</span>
                        <div>({diff.toLocaleString()})</div>
                      </>
                    )}

                  </td>
                  {!showHeatmap && (
                    <>
                      <td key={`${day}-special`} className="_nowrap text-center">
                        {province[`day${day}`].special_seats.toLocaleString()}
                      </td>
                      <td key={`${day}-cbt`} className="_nowrap text-center">
                        {province[`day${day}`].cbt_seats.toLocaleString()}
                      </td>
                    </>
                  )}
                </>
              )
            })}
          </tr>


        })}

      </tbody>
    </table>
  );
  // ---- เทียบปี 69: ที่นั่งสอบรายวัน (เฉพาะจำนวนคน ไม่เทียบห้อง) ----
  // ยอดปีนี้นับจาก examsites ที่โหลดมาแล้ว ส่วนปี 69 มาจาก snapshot examsitehistories ชุดเดียวกับหน้าศูนย์สอบ
  const currentSeatsByProvince = currentSeatsBy(sites, 'province');
  const historySeatsByProvince = historySeatsBy(historySites, 'province');
  const currentSeatsByCenter = currentSeatsBy(sites, 'center_code');
  const historySeatsByCenter = historySeatsBy(historySites, 'center_code');
  const centerNames = _.mapValues(_.groupBy(historySites, 'center_code'), (list) => get(list, '0.center_name'));

  const compareProvinceRows = [BKK_METRO_LABEL, ...PROVINCES]
    .map((province) =>
      buildCompareRow(province, province, (which, day) =>
        seatsOfProvince(which === 'current' ? currentSeatsByProvince : historySeatsByProvince, province, day),
      ),
    )
    .filter((row) => row.hasData);

  const compareCenterRows = _.sortBy(
    _.union(_.keys(currentSeatsByCenter), _.keys(historySeatsByCenter)),
  )
    .map((centerCode) =>
      buildCompareRow(centerCode, centerNames[centerCode] ? `${centerCode} ${centerNames[centerCode]}` : centerCode, (which, day) =>
        get(which === 'current' ? currentSeatsByCenter : historySeatsByCenter, [centerCode, day], 0),
      ),
    )
    .filter((row) => row.hasData);

  const onlyDecreased = (rows) =>
    compareOnlyNegative ? rows.filter((row) => DAYS.some((day) => row.days[day].diff < 0)) : rows;

  const renderCompareTable = (rows, labelHeader) => {
    const total = sumCompareRows(rows);
    return (
      <table className="t-table t-table-striped">
        <thead className="th-orange">
          <tr>
            <th rowSpan="2">ลำดับ</th>
            <th rowSpan="2">{labelHeader}</th>
            {DAYS.map((day) => (
              <th key={`head-${day}`} colSpan="3" className="text-center t-group-start">
                วันที่ {day}
              </th>
            ))}
          </tr>
          <tr>
            {DAYS.map((day) => (
              <React.Fragment key={`sub-${day}`}>
                <th className="text-right t-group-start">ปี {HISTORY_YEAR}</th>
                <th className="text-right">ปีนี้</th>
                <th className="text-right">ผลต่าง</th>
              </React.Fragment>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={row.key}>
              <td>{index + 1}</td>
              <td>{row.label}</td>
              {DAYS.map((day) => (
                <React.Fragment key={`${row.key}-${day}`}>
                  <td className="_nowrap text-right t-group-start">{num(row.days[day].previous)}</td>
                  <td className="_nowrap text-right">
                    <b>{num(row.days[day].current)}</b>
                  </td>
                  <td className="_nowrap text-right">
                    <DiffValue current={row.days[day].current} previous={row.days[day].previous} />
                  </td>
                </React.Fragment>
              ))}
            </tr>
          ))}
          <tr style={{ fontWeight: 'bold', background: '#fff6e5' }}>
            <td colSpan="2">รวม ({rows.length} รายการ)</td>
            {DAYS.map((day) => (
              <React.Fragment key={`total-${day}`}>
                <td className="_nowrap text-right t-group-start">{num(total.days[day].previous)}</td>
                <td className="_nowrap text-right">{num(total.days[day].current)}</td>
                <td className="_nowrap text-right">
                  <DiffValue current={total.days[day].current} previous={total.days[day].previous} />
                </td>
              </React.Fragment>
            ))}
          </tr>
        </tbody>
      </table>
    );
  };

  console.log(groupedByProvince)
  const displayProvinces = showOnlyEmpty ? groupedByProvince.filter(province => {
    return DAYS.every(day => province[`day${day}`].seats === 0);
  }) : groupedByProvince;

  const filteredProvinces = showHeatmap && showOnlyNegative
    ? displayProvinces.filter(province => {
      return DAYS.some(day => {
        const lyProvinceData = lastyearProvinceData[province.province];
        if (lyProvinceData && lyProvinceData[`day${day}`]) {
          const diff = province[`day${day}`].seats - lyProvinceData[`day${day}`];
          return diff < 0;
        }
        return false;
      });
    })
    : displayProvinces;

  const displayCenters = showOnlyEmpty ? groupedByCenter.filter(center => {
    return DAYS.every(day => center[`day${day}`].seats === 0);
  }) : groupedByCenter;
  console.log(displayCenters, groupedByCenter)

  const tabItems = [
    {
      key: '1',
      label: 'สนามสอบทั้งหมด',
      children: (
        <div>
          <h2>
            <span>
              <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18.75 8.50001H16.5V4.00001C16.5 3.75251 16.378 3.52101 16.1735 3.38101L11.4235 0.131006C11.168 -0.0439941 10.8315 -0.0439941 10.5765 0.131006L5.8265 3.38101C5.622 3.52101 5.5 3.75251 5.5 4.00001V8.50001H3.25C1.7335 8.50001 0.5 9.73401 0.5 11.25V20.25C0.5 20.664 0.8355 21 1.25 21H20.75C21.1645 21 21.5 20.664 21.5 20.25V11.25C21.5 9.73401 20.2665 8.50001 18.75 8.50001ZM5.25 17.5C5.25 17.776 5.026 18 4.75 18H4.25C3.974 18 3.75 17.776 3.75 17.5V15C3.75 14.724 3.974 14.5 4.25 14.5H4.75C5.026 14.5 5.25 14.724 5.25 15V17.5ZM5.25 12.5C5.25 12.776 5.026 13 4.75 13H4.25C3.974 13 3.75 12.776 3.75 12.5V12C3.75 11.724 3.974 11.5 4.25 11.5H4.75C5.026 11.5 5.25 11.724 5.25 12V12.5ZM8.5 17.5C8.5 17.776 8.276 18 8 18H7.5C7.224 18 7 17.776 7 17.5V15C7 14.724 7.224 14.5 7.5 14.5H8C8.276 14.5 8.5 14.724 8.5 15V17.5ZM8.5 12.5C8.5 12.776 8.276 13 8 13H7.5C7.224 13 7 12.776 7 12.5V12C7 11.724 7.224 11.5 7.5 11.5H8C8.276 11.5 8.5 11.724 8.5 12V12.5ZM11.75 17.5C11.75 17.776 11.526 18 11.25 18H10.75C10.474 18 10.25 17.776 10.25 17.5V15C10.25 14.724 10.474 14.5 10.75 14.5H11.25C11.526 14.5 11.75 14.724 11.75 15V17.5ZM11.75 12.5C11.75 12.776 11.526 13 11.25 13H10.75C10.474 13 10.25 12.776 10.25 12.5V12C10.25 11.724 10.474 11.5 10.75 11.5H11.25C11.526 11.5 11.75 11.724 11.75 12V12.5ZM11 9.00001C9.8955 9.00001 9 8.10451 9 7.00001C9 5.89551 9.8955 5.00001 11 5.00001C12.1045 5.00001 13 5.89551 13 7.00001C13 8.10451 12.1045 9.00001 11 9.00001ZM15 17.5C15 17.776 14.776 18 14.5 18H14C13.724 18 13.5 17.776 13.5 17.5V15C13.5 14.724 13.724 14.5 14 14.5H14.5C14.776 14.5 15 14.724 15 15V17.5ZM15 12.5C15 12.776 14.776 13 14.5 13H14C13.724 13 13.5 12.776 13.5 12.5V12C13.5 11.724 13.724 11.5 14 11.5H14.5C14.776 11.5 15 11.724 15 12V12.5ZM18.25 17.5C18.25 17.776 18.026 18 17.75 18H17.25C16.974 18 16.75 17.776 16.75 17.5V15C16.75 14.724 16.974 14.5 17.25 14.5H17.75C18.026 14.5 18.25 14.724 18.25 15V17.5ZM18.25 12.5C18.25 12.776 18.026 13 17.75 13H17.25C16.974 13 16.75 12.776 16.75 12.5V12C16.75 11.724 16.974 11.5 17.25 11.5H17.75C18.026 11.5 18.25 11.724 18.25 12V12.5Z"
                  fill="#FF8A00"
                />
              </svg>
            </span>{' '}
            มีสนามสอบ {sites.length} แห่ง
          </h2>
          {renderSiteTable(sites)}
        </div>
      ),
    },
    {
      key: '2',
      label: 'สนามสอบแยกตามศูนย์',
      children: (
        <div>
          {displayCenters.map((center) => (
            <div key={center.center_code}>
              <h3>ศูนย์สอบ: {center.center_code}</h3>
              {renderSiteTable(center.sites)}
              <br />
            </div>
          ))}
        </div>
      ),
    },
    {
      key: '3',
      label: 'แยกตามจังหวัด',
      children: (
        <div>
          <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'flex-end' }}>
            <span style={{ fontWeight: 'bold' }}>แสดงความเพียงพอสนาม</span>
            <Switch checked={showHeatmap} onChange={(checked) => setShowHeatmap(checked)} />
            {showHeatmap && (
              <>
                <span style={{ fontWeight: 'bold', marginLeft: '16px' }}>แสดงเฉพาะที่ไม่พอ</span>
                <Switch checked={showOnlyNegative} onChange={(checked) => setShowOnlyNegative(checked)} />
              </>
            )}
          </div>

          {renderProvinceTable(filteredProvinces)}

        </div>
      ),
    },
    {
      key: '4',
      label: `เทียบปี ${HISTORY_YEAR}`,
      children: (
        <div>
          {historySites.length === 0 ? (
            <p>ยังไม่มีข้อมูลสนามสอบปี {HISTORY_YEAR} ให้เทียบ</p>
          ) : (
            <>
              <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'flex-end' }}>
                <span style={{ fontWeight: 'bold' }}>แสดงเฉพาะที่ที่นั่งลดลง</span>
                <Switch checked={compareOnlyNegative} onChange={(checked) => setCompareOnlyNegative(checked)} />
              </div>
              <p style={{ color: '#828897' }}>
                เทียบที่นั่งสอบรายวัน (รวมห้องปกติ + ห้องพิเศษ + CBT ของปี {HISTORY_YEAR}) ระหว่างปี {HISTORY_YEAR} กับปีนี้
              </p>

              <h3>แยกตามศูนย์สอบ</h3>
              {renderCompareTable(onlyDecreased(compareCenterRows), 'ศูนย์สอบ')}
              <br />

              <h3>แยกตามจังหวัด</h3>
              {renderCompareTable(onlyDecreased(compareProvinceRows), 'จังหวัด')}
            </>
          )}
        </div>
      ),
    },
  ];

  return (
    <div>
      <Spin spinning={loading} delay={0}>
        <div>
          <div className="t-main">
            <div className="flex justify-between">
              <h1>ข้อมูลศูนย์สอบ</h1>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span>{showOnlyEmpty ? 'แสดงเฉพาะที่ยังไม่มีข้อมูล' : 'แสดงทั้งหมด'}</span>
                <Switch checked={showOnlyEmpty} onChange={(checked) => setShowOnlyEmpty(checked)} />
              </div>

            </div>


            <Tabs defaultActiveKey={DEFAULT_KEY}>
              {tabItems.map((item) => (
                <Tabs.TabPane tab={item.label} key={item.key}>
                  {item.children}
                </Tabs.TabPane>
              ))}
            </Tabs>
            <br />
          </div>
        </div>
      </Spin>
      <DownloadModal
        setIsVisible={setModalVisible}
        isVisible={modalVisible}
        centerCode={me.center_code}
      ></DownloadModal>
    </div>
  );

};
